import { Tables } from "@/supabase/types"
import { RealtimePostgresChangesPayload } from "@supabase/supabase-js"
import { Dispatch, SetStateAction } from "react"
import { printObject } from '@/lib/utils'
import { HandlerConfig } from "../base-subscription-manager"
import { v4 as uuidv4 } from "uuid"
import { createClientLogger } from "@/utils/logger/clientLogger"

const logger = createClientLogger('realtime.providers')

type Row = Tables<'providers'>

/**
 * This method doesn't handle insert since at that time the workspaces are not known.
 * It also doesn't handle delete since workspace relationship join table is better suited since it covers all cases
 * @param setProviders
 * @returns
 */
export function makeProviderHandler(
	setProviders: Dispatch<SetStateAction<Row[]>>
): HandlerConfig<Row> {
	const uuid = uuidv4()
	return {
		key: `providers-${uuid}`,
		channelName: `providers-${uuid}`,
		events: ['INSERT', 'UPDATE', 'DELETE'],
		schema: 'public',
		table: 'providers',
		handler: async (payload: RealtimePostgresChangesPayload<Row>) => {
			if (payload.eventType == "INSERT") {
				const provider = payload.new as Row
				setProviders(prev => {
					if (prev.some(p => p.id === provider.id)) return prev
					logger.info(`Handling provider Insert:${printObject(provider)}`)
					return [...prev, provider]
				})
			}
			else if (payload.eventType === 'UPDATE') {
				const provider = payload.new as Row
				setProviders(prev => {
					const exists = prev.some(p => p.id === provider.id)
					if (!exists) return prev // No change, no re-render
					logger.info(`Handling provider update:${printObject(provider)}`)
					return prev.map(p => p.id === provider.id ? provider : p)
				})
			}
			else if (payload.eventType == "DELETE") {
				const provider = payload.old as Row
				setProviders(prev => {
					const exists = prev.some(p => p.id === provider.id)
					if (!exists) return prev // No change, no re-render
					logger.info(`Handling provider Delete:${provider.id}`)
					return prev.filter(p => p.id !== provider.id)
				})
			}
		},
		inactivityThreshold: 1_800_000
	}
}